import { render } from "./SubmenuTopGuestMore.vue?vue&type=template&id=5ec270d0&scoped=true"
import script from "./SubmenuTopGuestMore.vue?vue&type=script&lang=js"
export * from "./SubmenuTopGuestMore.vue?vue&type=script&lang=js"

import "./SubmenuTopGuestMore.vue?vue&type=style&index=0&id=5ec270d0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec270d0"]])

export default __exports__